import api from "../../../api/userManagement/index"

export default {
  getUserInfo({}, params) {
    return api.getUserInfo(params).then(res => res.data)
  },
  removeUser({}, params) {
    return api.removeUser(params).then(res => res.data)
  },
  editUserInfo({}, params) {
    return api.editUserInfo(params).then(res => res.data)
  },
  updateUserPassword({}, params) {
    return api.updateUserPassword(params).then(res => res.data)
  },
}